module.exports = __webpack_public_path__ + "img/logo.b60959da.png";